export var DIRECTION_HORIZONTAL = 'horizontal';
export var DIRECTION_VERTICAL = 'vertical';
export var DEFAULT_LABELS_COUNTRY = 'en_au';
export var MIN_DEVICE_SIZE_DESKTOP = 768;
export var MIN_DEVICE_SIZE_TABLET = 601;
export var MAX_DESKTOP_VARIANTS = 3;